<div class="toggle-switch-container">
  <input
    type="checkbox"
    class="toggle-switch-checkbox"
    [id]="toggleId"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChange($any($event.target).checked)"
    hidden
  />
  <label
    [class.toggle-switch-checkbox:disabled]="disabled"
    class="toggle-switch"
    [for]="toggleId"
  >
    <div class="toggle-switch-slider">
      <div class="toggle-switch-knob">{{ checked ? onLabel : offLabel }}</div>
      <span class="toggle-switch-on"> {{ offLabel }}</span>
      <span class="toggle-switch-off"> {{ onLabel }}</span>
    </div>
  </label>
  <span *ngIf="label" class="toggle-switch-label">{{ label }}</span>
</div>
